<!-- /src/components/Relationships/Sidebar.vue -->
<template>
  <aside class="sidebar relationship-sidebar">
    <ul class="relationship-sidebar__action-bar">
      <li class="relationship-sidebar__action-bar__item">
        <button
          class="button button--medium button--shadow button--withIcon"
          :class="bookmarkClasses"
          @click.stop.prevent="addBookmark"
        >
          <span class="button__icon">
            <i v-if="bookmarkLoading" class="icon fas fa-spinner fa-pulse"></i>
            <i v-else-if="bookmarked" class="icon fas fa-bookmark"></i>
            <i v-else class="icon far fa-bookmark"></i>
          </span>
          <span class="button__text">{{ bookmarkText }}</span>
        </button>
      </li>
    </ul>

    <header class="relationship-sidebar__header">
      <h1>
        <img
          v-if="relationshipLogo"
          class="relationship-sidebar__headerLogo"
          :src="relationshipLogo"
          :alt="post.title.rendered + ' Logo'"
        />
        <span
          v-else
          class="relationship-sidebar__headerTitle"
          v-html="post.title.rendered"
        ></span>

        <div v-if="isMVP"
          class="relationship-sidebar__header__mvp-banner">
          MVP
        </div>

      </h1>
    </header>

    <button
      v-if="companyProfile && companyProfile.content"
      class="content__links"
      :class="{ active: companyProfile.isActive }"
      @click="setContent('companyProfile')"
    >
      <h3 class="relationship-sidebar__header">
        Company Profile
        <i class="fal fa-angle-double-right icon-content"></i>
      </h3>
    </button>

    <button
      v-if="bestPractices && bestPractices.content"
      class="content__links"
      :class="{ active: bestPractices.isActive }"
      @click="setContent('bestPractices')"
    >
      <h3 class="relationship-sidebar__header">
        Best Practices
        <i class="fal fa-angle-double-right icon-content"></i>
      </h3>
    </button>

    <button
      v-if="relatedSessions && relatedSessions.content"
      class="content__links"
      :class="{ active: relatedSessions.isActive }"
      @click="setContent('relatedSessions')"
    >
      <h3 class="relationship-sidebar__header">
        Media
        <i class="fal fa-angle-double-right icon-content"></i>
      </h3>
    </button>

    <button
      v-if="documents && documents.content"
      class="content__links"
      :class="{ active: documents.isActive }"
      @click="setContent('documents')"
    >
      <h3 class="relationship-sidebar__header">
        Documents
        <i class="fal fa-angle-double-right icon-content"></i>
      </h3>
    </button>

    <template v-if="relManagers && relManagers.length > 0">
      <h3 class="relationship-sidebar__header">Relationship Managers</h3>
      <ul class="relationship-sidebar__authors">
        <li
          v-for="(relManager, index) in relManagers"
          :key="`relationship-author_${index}`"
        >
          <ContactChip :bio="relManager" />
        </li>
      </ul>
    </template>

    <a v-if="requestRoster" :href="requestRoster" class="big-button"
      >Request Roster</a
    >

    <div class="sidebar__taxies">
      <TaxonomyGroup
        v-for="(taxGroup, int) in taxiesGroup"
        :key="int"
        :sessionType="'relationships'"
        :label="taxGroup.label"
        :queryProp="taxGroup.queryProp"
        :taxies="taxGroup.taxies"
        :itemStyle="taxGroup.style"
      />
    </div>
  </aside>
</template>

<script>
import ContactChip from '@/components/Bio/ContactChip'
import ContentModal from '@/components/common/Modal/ContentModal'

import { taxiesGroup } from '@/mixins/postSidebarMixin.js'
import postMixin from '@/mixins/postMixin'
import { isPromise, deepSearch } from '@/components/common/utils/helpers.js'

export default {
  props: {
    post: Object,
    initialActiveContent: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeContent: '',
    }
  },

  mixins: [taxiesGroup, postMixin],

  computed: {
    relationshipLogo() {
      return this.post.logo
    },

    relManagers() {
      const { rel_managers } = this.post
      const managers =
        rel_managers && rel_managers.length > 0
          ? this.$store.getters['taxies/findItemsByIDArray'](
              'rel_managers',
              rel_managers,
            )
          : false
      return managers
    },

    acf() {
      const { acf } = this.post
      return acf ? acf : false
    },

    requestRoster() {
      const { include_request_roster } = this.acf

      if (include_request_roster) {
        return `mailto:request.roster@carr.us`
      }
      return false
    },

    contentElements() {
      const { initialActiveContent } = this
      return initialActiveContent
    },

    documents() {
      const { contentElements } = this
      const documents = deepSearch(contentElements, ['documents'])
      return documents
    },

    relatedSessions() {
      const { contentElements } = this
      const relatedSessions = deepSearch(contentElements, ['relatedSessions'])
      return relatedSessions
    },

    bestPractices() {
      const { contentElements } = this
      const bestPractices = deepSearch(contentElements, ['bestPractices'])
      return bestPractices
    },

    companyProfile() {
      const { contentElements } = this
      const companyProfile = deepSearch(contentElements, ['companyProfile'])
      return companyProfile
    },

    links() {},
  },

  methods: {
    setContent(value) {
      this.$emit('clicked', value)
    },

    setActiveContent() {
      const { initialActiveContent } = this
      return initialActiveContent
    },

    isPromise() {
      return isPromise
    },
  },

  components: {
    ContactChip,
  },

  mounted() {
    // this.contentElements = this.setActiveContent()
  },

  filters: {},
}
</script>

<style scoped>
.relationship-sidebar {
  &__action-bar {
    width: 100%;
    margin: 0 0 1rem 0;
    list-style: none;
    font-size: 0.7em;
    /* display: grid;
    grid-template-columns: auto auto;
    grid-gap: 1em; */

    &__item {
      margin: 0;
      padding: 0;
      position: relative;
      .button {
        width: 100%;
      }

      &--active {
        .session__action-bar__item__dropdown {
          opacity: 1;
        }
      }
    }
  }

  &__header {
    margin-bottom: 0.5rem;
    position: relative;

    &Title {
      color: var(--brandPrimary);
      margin: 0;
      font-size: 1.65rem;
      font-weight: var(--fontWeightBold);
      line-height: 1;
    }

    &Logo {
      width: 100%;
      height: auto;
    }

    &__mvp-banner {
    position: absolute;
    top: -.3rem;
    right: -.5rem;
    background-color: var(--brandAccent);
    border-radius: 4px 4px 0 4px;
    padding: .2rem .5rem .2rem .5rem;
    color: white;
    font-size: .6rem;
    z-index: 3;
    font-weight: 800;

      &::after {
        content: "";
        background-color: #ac5412;
        width: .5rem;
        height: .5rem;
        bottom: -.5rem;
        right: 0;
        z-index: 5;
        position: absolute;
        letter-spacing: .03rem;
        clip-path: polygon(0% 0%, 100% 0%, 0% 100%)
      }
    }

  }

  &__meta {
    display: flex;
    color: var(--black);
    font-size: 0.6rem;
    font-weight: var(--fontWeightSemibold);
    margin-top: 0.5rem;

    &__item {
      &:after {
        content: '·';
        margin: 0 5px;
        display: inline-block;
      }

      &:last-child:after {
        content: '';
        margin: 0;
      }
    }
  }

  &__authors {
    li {
      margin-bottom: 0.5rem;
    }
  }

  &__table-of-contents {
    &__item {
      cursor: pointer;
      font-size: 0.7em;
      background-color: var(--lightGray);
      margin-bottom: 0.5rem;
      padding: 0.4rem 0.75rem;
      transition: all 0.25s;
      border-radius: var(--borderRadiusSmall);

      &:hover {
        background-color: var(--brandAccent);
        color: white;
        .relationship-sidebar__table-of-contents__itemTitle {
          color: white;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__itemTitle {
      font-weight: var(--fontWeightBold);
      text-transform: uppercase;
      color: var(--brandPrimary);
    }
  }

  .section-header {
    margin-bottom: 0.5rem;
    h3 {
      text-transform: uppercase;
      font-weight: var(--fontWeightBold);
      font-size: 0.7em;
      color: var(--gray);
      margin-bottom: 0;
    }

    &__description {
      font-size: 0.6em;
      color: var(--gray);
      font-style: italic;
    }
  }

  button.content__links {
    border: none;
    background: none;
    padding: 0;
    display: block;
    outline: none;
    cursor: pointer;
    margin-bottom: 0.5rem;
    margin-left: -1rem;
    padding-left: 1rem;
    padding-top: 0.5rem;
    width: calc(100% + var(--itemSpacing) + 1rem);
    border-radius: 4px 0 0 4px;
    text-align: left;
    /* margin-right: - var(--itemSpacing) ; */
    transition: all 200ms;
    position: relative;

    &.active {
      background-color: var(--lightGray);
      cursor: default;

      &:hover {
        background-color: var(--lightGray);
        h3 {
          color: var(--brandPrimary);
        }
      }
    }

    &:hover {
      background-color: var(--brandAccent);
      h3 {
        color: white;
      }
    }

    h3 {
      color: var(--brandPrimary);
    }
  }

  .big-button {
    padding: 0.5em;
    border-radius: 4px;
    background-color: var(--lightGray);
    margin-bottom: 0.5em;
    display: block;
    font-size: 0.9em;
    transition: 300ms all;

    &:hover {
      background-color: var(--brandAccent);
      color: white;
    }
  }

  .icon-content {
    position: absolute;
    right: 1rem;
    display: inline-block;
  }

  .back--container {
    /* display: grid;
    grid  */
  }
}
</style>
